// src/config/personalStatement.js
//
// Copy + field definitions for the Personal Statement service (public landing
// page + isolated request flow). DATA ONLY (no JSX): scripts/prerender.mjs
// imports this at build time to bake the marketing copy into static HTML, the
// same way it imports DEFAULT_SITE_TEXT -- so the crawler-visible page and the
// live React page can never drift.
//
// The indicative PRICE is deliberately NOT here: it lives in siteText
// (`personalStatement.indicativePrice` / `.feeNote`) so Danielle can edit it
// live via the Site Text admin tab with no deploy. It is display-only -- the
// actual fee is quoted per request through the existing serviceRequests flow.

export const PS_EYEBROW = 'Personal Statements';
export const PS_TITLE = "Your personal statement, read by an examiner's eye.";
export const PS_LEDE = 'One-to-one guidance and line-by-line review for UCAS and overseas university applications -- from a Hong Kong educator who has helped students win places on the most competitive courses.';

export const PS_PROOF_EYEBROW = 'Track record';
export const PS_PROOF_LINE = 'A student Danielle guided earned a place to read Medicine at UCL.';

// The two services. `mode` maps to the request flow's ?type= parameter.
export const PS_SERVICES = [
    {
        mode: 'review',
        title: 'Personal Statement Review',
        body: "Send your draft and get specific, honest feedback on content, structure and language -- shaped around what admissions tutors actually look for. You'll know exactly what's working, what to cut, and what to sharpen so it sounds like you at your best.",
        cta: 'Request a review'
    },
    {
        mode: 'consultation',
        title: 'Admissions Consultation',
        body: "Talk it through in a one-to-one session: your course choice, your story, and how to position it -- before you write, or when you're stuck. Strategy and direction, not just corrections.",
        cta: 'Book a consultation'
    }
];

export const PS_STEPS = [
    'Send your draft, or request a session.',
    'Danielle reviews it and sends you a fee quote.',
    'Review your quote in your account. Pay by card through Stripe, or use PayMe / FPS.',
    'Receive written feedback -- or meet for your session.'
];

export const PS_AUDIENCE_LINE = 'Students applying through UCAS or overseas -- especially for competitive courses where every line counts.';
export const PS_AUDIENCE_PILLS = [
    'UCAS applicants',
    'Medicine & Law',
    'HK students applying abroad',
    'Oxbridge & Russell Group'
];

// Honest scope + fee framing. Rendered verbatim; also baked into the static page.
export const PS_DISCLAIMER = 'Every application is different; fees are quoted per request. Guidance and editing support only -- the words, and the outcome, remain your own.';

// Shown when siteText.personalStatement.indicativePrice is blank.
export const PS_PRICE_FALLBACK = 'Fees are quoted per request.';

// ---- SEO (used by scripts/prerender.mjs and the in-app document title) ----
export const PS_SEO = {
    title: 'Personal Statement Help Hong Kong -- UCAS Review & Admissions Consultation | Between the Lines with Danielle',
    description: 'Personal statement review and university admissions consultation for Hong Kong students applying through UCAS and overseas -- line-by-line feedback from an experienced English educator.',
    serviceType: 'Personal statement review and university admissions consultation'
};

// ---- Optional applicant info (BOTH request modes) ----
// Industry-standard set; every field is optional and only written to the
// serviceRequests payload when non-empty (keeps the payload well under the
// 30-key rules cap and avoids storing empty strings).
export const PS_APPLICANT_FIELDS = [
    { key: 'currentSchool', label: 'Current school', placeholder: 'e.g. Diocesan Girls’ School', max: 120 },
    { key: 'yearOrGrade', label: 'Year / grade', placeholder: 'e.g. Year 13 / S6', max: 60 },
    { key: 'targetUniversities', label: 'Target universities', placeholder: 'e.g. UCL, Edinburgh, HKU', max: 300 },
    { key: 'targetCourse', label: 'Target course', placeholder: 'e.g. Medicine', max: 120 },
    { key: 'applicationDeadline', label: 'Application deadline', placeholder: 'e.g. 15 October', max: 60 }
];
